export default __webpack_public_path__ + "static/media/miscellaneous08.6ce7eaf7.png";